import { memo, useEffect, useRef } from 'react'
import fieldInputConnector from 'root/src/client/logic/form/connectors/fieldInputConnector'
import RadioButton from 'root/src/client/web/base/RadioButton'
import map from 'ramda/src/map'
import classNames from 'classnames'

const styles = {
	root: {
		margin: [[10, 0, 0]],
		justifyContent: 'space-around',
	},
}

const getRadioInputValue = (fieldValue) => {
	if (typeof fieldValue === 'boolean') {
		return fieldValue
	}
	return fieldValue?.value
}

const RadioInput = memo(
	({
		classes,
		fieldOptions,
		setInput,
		moduleKey,
		fieldPath,
		onExit,
		fieldValue,
		clearFormInputs,
	}) => {
		const elementRef = useRef()

		useEffect(() => {
			setInput(
				getRadioInputValue(fieldValue),
				moduleKey,
				fieldPath,
				onExit,
				elementRef.current,
			)
		}, [])

		return (
			<div
				ref={elementRef}
				className={classNames('flex layout-row', classes.root)}
			>
				{map((radioOption) => {
					const checked =	radioOption.value === fieldValue.value
						|| radioOption.value === fieldValue
					return (
						<RadioButton
							key={radioOption.value}
							id={radioOption.value}
							checked={checked}
							label={radioOption.label}
							onClick={() => setInput(
								radioOption.value,
								moduleKey,
								fieldPath,
								onExit,
								elementRef.current,
								undefined,
								clearFormInputs,
							)}
						/>
					)
				}, fieldOptions)}
			</div>
		)
	},
)

export default memo(fieldInputConnector(RadioInput, styles, 'MuiRadioInput'))
